/**
 * @generated SignedSource<<1af034bac11f25b1880872d2719c1153>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SpaceVisibility = "PRIVATE" | "PUBLIC" | "SECRET" | "%future added value";
export type spaceHeadQuery$variables = {
  club: string;
  space: string;
};
export type spaceHeadQuery$data = {
  readonly club: {
    readonly name: string;
    readonly space: {
      readonly name: string;
      readonly slug: string;
      readonly visibility: SpaceVisibility;
    };
  };
};
export type spaceHeadQuery = {
  response: spaceHeadQuery$data;
  variables: spaceHeadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "club"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "space"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "club"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "space"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "spaceHeadQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "spaceHeadQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "101f9b0d7dc4e7413917d7c8f2f848f3",
    "id": null,
    "metadata": {},
    "name": "spaceHeadQuery",
    "operationKind": "query",
    "text": "query spaceHeadQuery(\n  $club: String!\n  $space: String!\n) {\n  club(slug: $club) {\n    name\n    space(slug: $space) {\n      __typename\n      slug\n      name\n      visibility\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "91a35f77218f187412de73a3e9afd939";

export default node;
